export var EPaymentOrderRole;
(function (EPaymentOrderRole) {
    EPaymentOrderRole["Read"] = "READ";
    EPaymentOrderRole["Write"] = "WRITE";
})(EPaymentOrderRole || (EPaymentOrderRole = {}));
export var EPaymentOrderType;
(function (EPaymentOrderType) {
    // Creatable - Recurring => Custom frontend, not a real type in the API
    EPaymentOrderType["RentAndCosts"] = "RENT_AND_COSTS";
    // Creatable - Recurring
    EPaymentOrderType["Rent"] = "RENT";
    EPaymentOrderType["CommonCosts"] = "COMMON_COSTS";
    EPaymentOrderType["NonCommonCosts"] = "NON_COMMON_COSTS";
    EPaymentOrderType["ManagementCosts"] = "MANAGEMENT_COSTS";
    EPaymentOrderType["Rentio"] = "RENTIO";
    EPaymentOrderType["OtherRecurring"] = "OTHER_RECURRING";
    // Creatable - Non recurring
    EPaymentOrderType["LocationDescription"] = "LOCATION_DESCRIPTION";
    EPaymentOrderType["BrokerFee"] = "BROKER_FEE";
    EPaymentOrderType["OtherOneoff"] = "OTHER_ONEOFF";
    // Non creatable - Recurring
    EPaymentOrderType["RentDiscount"] = "RENT_DISCOUNT";
    // Non creatable - Non recurring
    EPaymentOrderType["IndexationCorrectionRent"] = "INDEXATION_CORRECTION";
    EPaymentOrderType["IndexationCorrectionCommonCosts"] = "INDEXATION_CORRECTION_COMMON_COSTS";
    EPaymentOrderType["IndexationCorrectionNonCommonCosts"] = "INDEXATION_CORRECTION_NON_COMMON_COSTS";
    EPaymentOrderType["IndexationCorrectionManagementCosts"] = "INDEXATION_CORRECTION_MANAGEMENT_COSTS";
    EPaymentOrderType["IndexationCorrectionRentio"] = "INDEXATION_CORRECTION_RENTIO";
    EPaymentOrderType["IndexationCorrectionOtherRecurring"] = "INDEXATION_CORRECTION_OTHER_RECURRING";
    EPaymentOrderType["IndexationRetroactiveRent"] = "INDEXATION_RETROACTIVE";
    EPaymentOrderType["IndexationRetroactiveCommonCosts"] = "INDEXATION_RETROACTIVE_COMMON_COSTS";
    EPaymentOrderType["IndexationRetroactiveNonCommonCosts"] = "INDEXATION_RETROACTIVE_NON_COMMON_COSTS";
    EPaymentOrderType["IndexationRetroactiveManagementCosts"] = "INDEXATION_RETROACTIVE_MANAGEMENT_COSTS";
    EPaymentOrderType["IndexationRetroactiveRentio"] = "INDEXATION_RETROACTIVE_RENTIO";
    EPaymentOrderType["IndexationRetroactiveOtherRecurring"] = "INDEXATION_RETROACTIVE_OTHER_RECURRING";
    EPaymentOrderType["RentDeposit"] = "RENT_DEPOSIT";
    EPaymentOrderType["RentDepositPayout"] = "RENT_DEPOSIT_PAYOUT";
})(EPaymentOrderType || (EPaymentOrderType = {}));
export var EPaymentOrderOwnerPaymentMethod;
(function (EPaymentOrderOwnerPaymentMethod) {
    EPaymentOrderOwnerPaymentMethod["FromRent"] = "FROM_RENT";
    EPaymentOrderOwnerPaymentMethod["Direct"] = "DIRECT";
})(EPaymentOrderOwnerPaymentMethod || (EPaymentOrderOwnerPaymentMethod = {}));
export var EPaymentRepetitionType;
(function (EPaymentRepetitionType) {
    EPaymentRepetitionType["Once"] = "ONCE";
    EPaymentRepetitionType["Monthly"] = "MONTHLY";
    EPaymentRepetitionType["Yearly"] = "YEARLY";
    EPaymentRepetitionType["Quarterly"] = "QUARTERLY";
})(EPaymentRepetitionType || (EPaymentRepetitionType = {}));
var EPaymentFeatures;
(function (EPaymentFeatures) {
    EPaymentFeatures["BancontactBankWireOnly"] = "BANCONTACT_BANKWIRE_ONLY";
    EPaymentFeatures["BancontactIbanisationOnly"] = "BANCONTACT_IBANISATION_ONLY";
    EPaymentFeatures["BancontactOnly"] = "BANCONTACT_ONLY";
    EPaymentFeatures["BlockedPayment"] = "BLOCKED_PAYMENT";
    EPaymentFeatures["BlockedPayout"] = "BLOCKED_PAYOUT";
    EPaymentFeatures["NoNotifications"] = "NO_NOTIFICATIONS";
    EPaymentFeatures["RentDeposit"] = "RENT_DEPOSIT";
})(EPaymentFeatures || (EPaymentFeatures = {}));
export var EPaymentGroupStatus;
(function (EPaymentGroupStatus) {
    EPaymentGroupStatus["New"] = "NEW";
    EPaymentGroupStatus["Active"] = "ACTIVE";
    EPaymentGroupStatus["Paused"] = "PAUSED";
    EPaymentGroupStatus["Stopped"] = "STOPPED";
    EPaymentGroupStatus["Ended"] = "ENDED";
    EPaymentGroupStatus["Expired"] = "EXPIRED";
    EPaymentGroupStatus["Deleted"] = "DELETED";
    EPaymentGroupStatus["Archived"] = "ARCHIVED";
    EPaymentGroupStatus["Error"] = "ERROR";
    EPaymentGroupStatus["ValidationError"] = "VALIDATION_ERROR";
    EPaymentGroupStatus["Empty"] = "EMPTY";
    // cspell:ignore chargerequest
    EPaymentGroupStatus["ChargeRequestError"] = "CHARGEREQUEST_ERROR";
})(EPaymentGroupStatus || (EPaymentGroupStatus = {}));
export var EPaymentMethod;
(function (EPaymentMethod) {
    EPaymentMethod["Sepa"] = "sepa";
    EPaymentMethod["SepaOnce"] = "sepa_once";
    EPaymentMethod["SepaRecurring"] = "sepa_recurring";
    EPaymentMethod["Ibanisation"] = "ibanisation";
    EPaymentMethod["BankWire"] = "bankwire";
    EPaymentMethod["Bancontact"] = "bancontact";
    EPaymentMethod["Payconiq"] = "payconiq";
    EPaymentMethod["Ideal"] = "ideal";
})(EPaymentMethod || (EPaymentMethod = {}));
export var EPayoutType;
(function (EPayoutType) {
    EPayoutType["Charge"] = "CHARGE";
    EPayoutType["Payout"] = "PAYOUT";
})(EPayoutType || (EPayoutType = {}));
export var EExternalBookkeepingType;
(function (EExternalBookkeepingType) {
    EExternalBookkeepingType["EasyInvoicing"] = "EF";
})(EExternalBookkeepingType || (EExternalBookkeepingType = {}));
export var ETransferType;
(function (ETransferType) {
    ETransferType["TransferPayout"] = "TRANSFER_PAYOUT";
    ETransferType["TransferAdministrative"] = "TRANSFER_ADMINISTRATIVE";
    ETransferType["TransferReverseAdministrative"] = "TRANSFER_REVERSE_ADMINISTRATIVE";
    ETransferType["Payout"] = "PAYOUT";
})(ETransferType || (ETransferType = {}));
export var ETransactionStatus;
(function (ETransactionStatus) {
    ETransactionStatus["Success"] = "success";
    // cSpell:ignore transfered
    ETransactionStatus["Transferred"] = "transfered";
    ETransactionStatus["Skipped"] = "skipped";
    ETransactionStatus["New"] = "new";
    ETransactionStatus["Paid"] = "paid";
})(ETransactionStatus || (ETransactionStatus = {}));
export var EMissingKYCStatus;
(function (EMissingKYCStatus) {
    EMissingKYCStatus["None"] = "none";
    EMissingKYCStatus["New"] = "new";
    EMissingKYCStatus["Requested"] = "requested";
    EMissingKYCStatus["Failed"] = "failed";
    EMissingKYCStatus["Approved"] = "approved";
})(EMissingKYCStatus || (EMissingKYCStatus = {}));
export var EMangoScaStatus;
(function (EMangoScaStatus) {
    EMangoScaStatus["NotEnrolled"] = "NOT_ENROLLED";
    EMangoScaStatus["Enrolled"] = "ENROLLED";
    EMangoScaStatus["Failed"] = "FAILED";
    EMangoScaStatus["Revoked"] = "REVOKED";
})(EMangoScaStatus || (EMangoScaStatus = {}));
export var EMangoPayKycFailedStatus;
(function (EMangoPayKycFailedStatus) {
    EMangoPayKycFailedStatus["DocumentUnreadable"] = "DOCUMENT_UNREADABLE";
    EMangoPayKycFailedStatus["DocumentNotAccepted"] = "DOCUMENT_NOT_ACCEPTED";
    EMangoPayKycFailedStatus["DocumentHasExpired"] = "DOCUMENT_HAS_EXPIRED";
    EMangoPayKycFailedStatus["DocumentIncomplete"] = "DOCUMENT_INCOMPLETE";
    EMangoPayKycFailedStatus["DocumentDoNotMatchUserData"] = "DOCUMENT_DO_NOT_MATCH_USER_DATA";
    EMangoPayKycFailedStatus["DocumentDoNotMatchAccountData"] = "DOCUMENT_DO_NOT_MATCH_ACCOUNT_DATA";
    EMangoPayKycFailedStatus["DocumentFalsified"] = "DOCUMENT_FALSIFIED";
    EMangoPayKycFailedStatus["UnderagePerson"] = "UNDERAGE_PERSON";
    EMangoPayKycFailedStatus["SpecificCase"] = "SPECIFIC_CASE";
})(EMangoPayKycFailedStatus || (EMangoPayKycFailedStatus = {}));
